export default __webpack_public_path__ + "static/media/foto_contracheque.7eecdb40.png";